































import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import Input from '@/components/common/inputs/input'
import * as ruleNames from '@/components/common/inputs/constants/ruleNames'

@Component
export default class EventTypeRadioInput extends mixins(Input) {
  @Prop(Array) options!: Array<{
    value: string | number
    label: string
    description: string
  }>

  showDiscription = null
  supportedRules: Array<string> = [ruleNames.REQUIRED]
}
